// Decorative art: its labels are part of the picture, not text to select.
.cover {
  position: relative;
  -webkit-user-select: none;
  user-select: none;
  width: 100%;
  aspect-ratio: 1200 / 630;
  overflow: hidden;
  border-radius: inherit;
  background:
    radial-gradient(
        circle,
        color-mix(in srgb, var(--color-foreground) 9%, transparent) 1.5px,
        transparent 1.5px
      )
      0 0 / 24px 24px,
    color-mix(in srgb, var(--color-primary) 5%, var(--color-background-2));
}

.art {
  display: block;
  width: 100%;
  height: 100%;
}

.raster::after {
  content: "";
  position: absolute;
  inset: 0;
  background: var(--cover-light) center / contain no-repeat;
}
.raster[data-theme="dark"]::after,
:global([data-theme="dark"]) .raster::after {
  background-image: var(--cover-dark);
}
